import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox, Field, Input, Select } from '@itds/elements/index.js';

import { AgencyContext } from '@brokerage/contexts/AgencyContext';

const General = ({ form_engine, saveFormEngine }) => {
  const { member_names } = useContext(AgencyContext);
  const [errors, setErrors] = useState([]);
  const [data, setData] = useState({
    is_deactivated: form_engine.is_deactivated || false,
    name: form_engine.name || '',
    member_id: form_engine.member_id || '',
    beta: form_engine.beta || false,
    is_archived: form_engine.is_archived || false
  });

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleCheckboxChange = (name, e) => {
    setData({ ...data, [name]: e.target.checked });
  };

  const handleDataSourceToggle = () => {
    setData({
      ...data,
      beta: !data.beta
    });
  };

  const handleSave = () => {
    const errors = [];

    if (!data.name) {
      errors.push('name');
    }

    setErrors(errors);

    if (!errors.length) {
      saveFormEngine(data);
    }
  };

  const handleArchiveToggle = () => {
    setData({ ...data, is_archived: !data.is_archived });
    saveFormEngine({ is_archived: !data.is_archived });
  };

  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <Checkbox
          checked={data.is_deactivated}
          disabled={data.is_archived}
          label='Deactivated'
          onChange={handleCheckboxChange.bind(null, 'is_deactivated')}
        />
      </div>

      <Field label='Name'>
        <Input
          invalid={errors.includes('name')}
          onChange={handleInputChange.bind(null, 'name')}
          readOnly={data.is_archived}
          required={true}
          value={data.name}
        />
      </Field>

      <Field label='Owner'>
        <Select
          onChange={handleInputChange.bind(null, 'member_id')}
          options={[{ value: '', label: 'Unassigned' }].concat(member_names)}
          readOnly={data.is_archived}
          value={data.member_id}
        />
      </Field>

      <Field label='Data Source'>
        <Select
          onChange={handleDataSourceToggle}
          options={[
            { value: false, label: 'Live' },
            { value: true, label: 'Beta' }
          ]}
          readOnly={data.is_archived}
          value={!!data.beta}
        />
      </Field>

      <div style={{ display: 'flex', marginTop: 30 }}>
        <Button color='RED' onClick={handleArchiveToggle} style={{ marginRight: 5 }}>
          {data.is_archived ? 'Unarchive' : 'Archive'}
        </Button>
        {data.is_archived ? null : <Button onClick={handleSave}>Save</Button>}
      </div>
    </>
  );
};

General.propTypes = {
  form_engine: PropTypes.shape({
    is_deactivated: PropTypes.bool,
    name: PropTypes.string,
    member_id: PropTypes.number,
    beta: PropTypes.bool,
    is_archived: PropTypes.bool
  }),
  saveFormEngine: PropTypes.func,
  setErrorMessage: PropTypes.func,
  setSuccessMessage: PropTypes.func
};

export default General;
